module.exports = __webpack_public_path__ + "static/media/14UNEP8.4a2c0bca.jpg";